import {
    AboutIntro,
    Aside1Section,
    Attractions,
    BackgroundBanner,
    RoomPreview,
    SpecialPreview,
    TopSection,
    VideoSection,
} from "@/domains/components";
import { Center, Flex, Spinner, Text } from "@chakra-ui/react";
import {
    useGetDMaxCommon,
    type AboutDmaxInfoResponse,
    type AroundDmaxInfoResponse,
    type Aside1DmaxInfoResponse,
    type MainInfoDmaxResponse,
    type RoomDMaxInfoResponse,
    type SpecialDmaxInfoResponse,
    type VideoDmaxInfoResponse,
} from "@shared/server";

export const Home = () => {
    const { data: main } = useGetDMaxCommon<MainInfoDmaxResponse>({ section: "main" });
    const { data: about } = useGetDMaxCommon<AboutDmaxInfoResponse>({ section: "about" });
    const { data: room } = useGetDMaxCommon<RoomDMaxInfoResponse>({ section: "room" });
    const { data: special } = useGetDMaxCommon<SpecialDmaxInfoResponse>({ section: "special" });
    const { data: aside1 } = useGetDMaxCommon<Aside1DmaxInfoResponse>({ section: "aside1" });
    const { data: around } = useGetDMaxCommon<AroundDmaxInfoResponse>({ section: "around" });
    const { data: video } = useGetDMaxCommon<VideoDmaxInfoResponse>({ section: "video" });
    return main && about && room && special && aside1 && video ? (
        <>
            <Flex flexDir={video.video_loc === "top" ? "column-reverse" : "column"}>
                <TopSection imgList={main.imgList} sector={main.sector} />
                <VideoSection data={video} />
            </Flex>
            <AboutIntro about={about} />
            <RoomPreview room={room} />
            <SpecialPreview special={special} />
            <BackgroundBanner img_URL={main.imgList[1]?.img_URL} />
            <Aside1Section aside1={aside1} />
            {around?.isUse && <Attractions around={around} />}
        </>
    ) : (
        <Center h="100vh" columnGap="8px">
            <Text>LOADING</Text>
            <Spinner />
        </Center>
    );
};
